'use client'
import ProductPreview from "@/app/components/pages/shop/ProductPreview";
import styles from '@/app/styles/components/pages/shop/product-list.module.scss'

const ProductList = ({products}) => {

    if (!products) {
        return ''
    }

    return <div className={styles.productListContainer}>
        {
            products.map((product, idx) => (
                <div key={`product-${idx}`} className={styles.productListItem}>
                    <ProductPreview product={product}/>
                </div>
            ))
        }

    </div>
}

export default ProductList